import { render, staticRenderFns } from "./MotionAlarmReportScreen.vue?vue&type=template&id=4bbf2648"
import script from "./MotionAlarmReportScreen.vue?vue&type=script&lang=js"
export * from "./MotionAlarmReportScreen.vue?vue&type=script&lang=js"
import style0 from "./MotionAlarmReportScreen.vue?vue&type=style&index=0&id=4bbf2648&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports